export default __webpack_public_path__ + "static/media/7.02d37b08.png";